<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :visible-field-form="false"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '계획일' },
      ]"
      :use-tab-codes="['facility']"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          안전계획_사업장명: [],
          안전계획_사업장주소: [],
          안전계획_사업장구분: [],
          안전계획_종류: [],
        };

        if (this.form.stdInfo.field_name) {
          value.summary["안전계획_사업장명"].push({
            [this.form.stdInfo.field_name]: 1,
          });
        }

        if (this.form.stdInfo.field_address) {
          value.summary["안전계획_사업장주소"].push({
            [this.form.stdInfo.field_address]: 1,
          });
        }

        if (this.form.stdInfo.facility_category && this.form.stdInfo.facility_category.cat1) {
          value.summary['안전계획_사업장구분'].push({
            [this.form.stdInfo.facility_category.cat1]: 1
          })
        }

        value.summary["안전계획_종류"].push({
          '은평구 중대시민재해 종합계획': 1,
          '중대시민재해 종합계획': 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
